import { isDefined, ROOT_PATH } from '../utils';
const EMPTY_OBJECT = {};
const FORWARD_SLASH_REGEX = /\//g;
export const errorsMapper = (errors = []) => {
    if (!isDefined(errors) || errors.length === 0) {
        return EMPTY_OBJECT;
    }
    return errors.reduce((acc, error) => {
        var _a;
        if (error.keyword !== 'required') {
            return acc;
        }
        const { instancePath, message, params: { missingProperty }, } = error;
        if (message) {
            const path = `${ROOT_PATH}${instancePath.replace(FORWARD_SLASH_REGEX, '.')}.${missingProperty}`;
            (_a = acc[path]) !== null && _a !== void 0 ? _a : (acc[path] = []);
            acc[path].push(message);
        }
        return acc;
    }, {});
};
//# sourceMappingURL=errors-mapper.js.map